/**
 * Passe-partout Cart — Atelier Toon
 *
 * 1. Verbergt de variant-select die Meta/Facebook Pixel injecteert.
 * 2. Injecteert een "Bekijk je ontwerp"-link in de Essential cart drawer
 *    voor passe-partout items, op basis van de _Voorbeeld cart-property.
 * 3. Injecteert een "Ontwerp bewerken"-link die de builder opent met het
 *    opgeslagen ontwerp (_ppb_state), zodat het item bijgewerkt kan worden.
 */
(function () {
  'use strict';

  /* ── 1. Verberg Meta/Facebook Pixel variant-select ───────────── */
  var CSS = 'select[aria-label*="Stel je eigen passe-partout"] { display: none !important; }';
  function injectCSS() {
    if (document.getElementById('ppb-fb-hide')) return;
    var s = document.createElement('style');
    s.id = 'ppb-fb-hide';
    s.textContent = CSS;
    document.head.appendChild(s);
  }
  injectCSS();
  new MutationObserver(injectCSS).observe(document.documentElement, { childList: true, subtree: false });

  /* ── 2. "Bekijk je ontwerp"- en "Ontwerp bewerken"-links in de drawer ── */

  function isEnglish() {
    return document.documentElement.lang.indexOf('en') === 0 ||
           window.location.pathname.indexOf('/en/') === 0;
  }

  function isGerman() {
    return document.documentElement.lang.indexOf('de') === 0 ||
           window.location.pathname.indexOf('/de/') === 0;
  }

  function makeLink(className, href, label, newTab) {
    var link = document.createElement('a');
    link.className = className;
    link.href = href;
    if (newTab) { link.target = '_blank'; link.rel = 'noopener'; }
    link.textContent = label;
    link.style.cssText = 'display:block;font-size:0.8em;margin-top:6px;color:inherit;text-decoration:underline;opacity:0.7;';
    return link;
  }

  function applyLinks() {
    var drawerItems = document.querySelectorAll('[data-essential-cart-element="cart-drawer-item"]');
    if (!drawerItems.length) return;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var isEN = isEnglish();
        var isDE = isGerman();

        items.forEach(function (item, i) {
          var itemProps  = item.properties || {};
          var previewUrl = itemProps['_Voorbeeld'] || itemProps['_Preview'];
          var editState  = itemProps['_ppb_state'];
          if (!previewUrl && !editState) return;

          var drawerItem = drawerItems[i];
          if (!drawerItem) return;

          /* Verberg alleen de variant-selector voor ppb-items (verwijderknop blijft zichtbaar) */
          var variantSel = drawerItem.querySelector('[data-essential-cart-element="line-item-variant-selector"]');
          if (variantSel) variantSel.style.setProperty('display', 'none', 'important');

          /* Niet twee keer injecteren */
          var links = [];
          if (previewUrl && !drawerItem.querySelector('.ppb-preview-link')) {
            links.push(makeLink('ppb-preview-link', previewUrl,
              isEN ? 'View your design →' : (isDE ? 'Entwurf ansehen →' : 'Bekijk je ontwerp →'), true));
          }
          if (editState && item.key && !drawerItem.querySelector('.ppb-edit-link')) {
            var base = String(item.url || '').split('?')[0];
            if (base) {
              links.push(makeLink('ppb-edit-link',
                base + '?ppb_edit=' + encodeURIComponent(item.key),
                isEN ? 'Edit design →' : (isDE ? 'Entwurf bearbeiten →' : 'Ontwerp bewerken →'), false));
            }
          }
          if (!links.length) return;

          /* Voeg in na de properties-lijst, in volgorde */
          var anchor  = drawerItem.querySelector('[data-essential-cart-element="line-item-properties"]');
          var details = drawerItem.querySelector('[data-essential-cart-element="cart-drawer-item-details"]');
          links.forEach(function (link) {
            if (anchor) {
              anchor.insertAdjacentElement('afterend', link);
              anchor = link;
            } else if (details) {
              details.appendChild(link);
            }
          });
        });
      })
      .catch(function () {});
  }

  /* Na cart-events */
  ['cart:updated', 'cart:open', 'cart:refresh', 'cart:added', 'on:cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(applyLinks, 200); });
  });

  /* DOM-mutaties — Essential herrendert de drawer */
  var mutationTimer;
  new MutationObserver(function () {
    clearTimeout(mutationTimer);
    mutationTimer = setTimeout(applyLinks, 150);
  }).observe(document.body, { childList: true, subtree: true });

  /* Eerste keer bij laden */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyLinks);
  } else {
    applyLinks();
  }

})();
